import { LayoutRenderLayoutItemOptions } from '../../../models/cv-layout-render.model';

export class PhotoGalleryOptions extends LayoutRenderLayoutItemOptions {
	showDescription?: boolean;
	filter?: string | string[];
	renderTemplate?: {
		rendererKey?: string
		rendererName?: string
	};
	size?: {
		width?: string
		height?: string
	};
	readDescriptionFromData?: {
		key: string | string[];
		separator?: string;
	};
	photosInData: boolean;
	showIfEmpty: boolean;

	constructor() {
		super();
		this.photosInData = true;
		this.showIfEmpty = false;
	}
}
